var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilcirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.3359 -75.1094 79.8575 79.8086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.19922C68.0176 4.19922 85.6934-13.4766 85.6934-35.2051C85.6934-56.9336 68.0176-74.6094 46.2402-74.6094C24.5117-74.6094 6.83594-56.9336 6.83594-35.2051C6.83594-13.4766 24.5117 4.19922 46.2402 4.19922Z M33.9355-17.9199L28.2715-15.9668C27.2461-15.625 26.1719-16.5527 26.6602-17.6758L28.8086-23.0957L53.9551-48.1934L59.1309-43.0176ZM61.7188-45.6055L56.543-50.7812L59.7168-53.9062C61.1328-55.2734 62.6953-55.4199 63.9648-54.1016L65.0391-53.0273C66.3086-51.7578 66.2598-50.1465 64.8438-48.7305Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilcirclefill);
export default __webpack_public_path__ + "static/media/pencil.circle.fill.61d3e54c6d92f9f9b59f85246803a3a0.svg";
export { ForwardRef as ReactComponent };